import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const Scrim=styled.div`
 position:fixed;left:0;right:0;top:var(--cu-app-top,0px);height:var(--cu-app-height,100dvh);z-index:17000;background:rgba(3,6,10,.72);display:flex;align-items:flex-end;justify-content:center;
 padding-top:max(24px,var(--cu-safe-top));
`;
const Panel=styled.section`
 width:min(100%,560px);max-height:calc(var(--cu-app-height,100dvh) - 24px);display:flex;flex-direction:column;min-height:0;
 border:1px solid #ffffff1b;border-bottom:0;border-radius:24px 24px 0 0;background:#161a21;color:#f3f5fa;
 box-shadow:0 -12px 48px #0005;padding-bottom:var(--cu-safe-bottom);overflow:hidden;
 header{padding:22px 20px 16px;display:flex;align-items:center;gap:12px;border-bottom:1px solid #ffffff0e;flex-shrink:0;}
 h2{font-size:20px;letter-spacing:-.04em;font-weight:650;flex:1;margin:0;}
 header button{width:44px;height:44px;padding:0;border-radius:50%;background:#ffffff0a;color:#c6ccd6;border:1px solid #ffffff12;font-size:22px;}
 .sheet-body{padding:20px;overflow:auto;overscroll-behavior:contain;min-height:0;}
 button,input,select{min-height:44px;}input,select,textarea{font-size:16px;}
 :focus-visible{outline:2px solid #b5a1ff;outline-offset:3px;}
 @media(min-width:761px){margin:auto;border-bottom:1px solid #ffffff1b;border-radius:24px;}
`;

export default function MobileSheet({title,onClose,children}) {
 const ref=useRef(null),closeRef=useRef(onClose),titleId=useId();closeRef.current=onClose;
 useEffect(()=>{
  const previous=document.activeElement,root=document.getElementById('root'),oldInert=root?.inert;
  if(root)root.inert=true;
  ref.current?.querySelector('[data-sheet-close]')?.focus();
  const keys=e=>{
   if(e.key==='Escape'){e.preventDefault();e.stopPropagation();closeRef.current();return;}
   if(e.key!=='Tab')return;
   const controls=[...ref.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]')].filter(el=>!el.hidden&&el.getAttribute('aria-hidden')!=='true');
   const first=controls[0],last=controls.at(-1);
   if(e.shiftKey&&(document.activeElement===first||!ref.current.contains(document.activeElement))){e.preventDefault();last?.focus();}
   else if(!e.shiftKey&&(document.activeElement===last||!ref.current.contains(document.activeElement))){e.preventDefault();first?.focus();}
  };
  document.addEventListener('keydown',keys,true);
  return()=>{document.removeEventListener('keydown',keys,true);if(root)root.inert=oldInert;previous?.focus?.();};
 },[]);
 return createPortal(<Scrim onPointerDown={e=>{if(e.target===e.currentTarget)onClose();}}><Panel ref={ref} role="dialog" aria-modal="true" aria-labelledby={titleId}>
  <header><h2 id={titleId}>{title}</h2><button type="button" data-sheet-close aria-label={`Close ${title}`} onClick={onClose}>×</button></header>
  <div className="sheet-body">{children}</div>
 </Panel></Scrim>,document.body);
}
